const sourceEnum = Object.freeze({
    WEB: 5,
    APP: 10,
    POS: 15,
});
export default sourceEnum;
